<script setup>
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps(['spread'])
const { locale } = useI18n()
const { updateCanvasIndex } = inject('canvasIndex')

const onTap = () => {
  updateCanvasIndex(props.spread[props.spread.length - 1].canvasIndex)
}

const title = (label) => {
  if (locale.value === 'es') {
    if (label['es'] && label['es'][0]) {
      return label['es'][0]
    }
  }

  if (label['en'][0]) {
    return label['en'][0]
  }

  return ''
}
</script>

<template>
  <div class="flex flex-col items-center" @click="onTap">
    <div class="flex flex-row justify-center">
      <img
        v-for="(canvas, i) in spread"
        :key="`${canvas.id}-thumbs-${i}`"
        :src="canvas.thumbnail.id"
        class="w-[100px] h-[150px] object-contain object-right even:object-left"
      >
    </div>
    
    <div class="text-sm pt-2 flex flex-wrap justify-center">
      <h3
        v-for="(canvas, i) in spread"
        :key="i"
        class="whitespace-pre"
      >
        {{ title(canvas.label) }}{{ i === spread.length - 1 ? '' : ', ' }}
    </h3>
    </div>
  </div>
</template>
